import {StripeContext} from './StripeContext'
import type {PropsWithChildren} from 'react'
import {api} from '../../trpc/api.ts'

export const StripeProvider = ({children}: PropsWithChildren) => {
  const {data: subscriptions = [], isFetching: loadingSubscriptions} = api.stripe.subscriptions.useQuery()
  const {mutateAsync: subscribe, isPending: subscribing} = api.stripe.subscribe.useMutation()
  const {mutateAsync: createPortalSession, isPending: creatingPortalSession} =
    api.stripe.createPortalSession.useMutation()

  return (
    <StripeContext.Provider
      value={{
        createPortalSession: async () => createPortalSession({}),
        creatingPortalSession,

        subscribe: async (request) => subscribe(request),
        subscribing,

        subscriptions,
        loadingSubscriptions,
      }}
    >
      {children}
    </StripeContext.Provider>
  )
}
